webpackJsonp([35783957827783],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ButtonModule = __webpack_require__(36);
	
	var _ButtonModule2 = _interopRequireDefault(_ButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var color = _ref.color,
	        text = _ref.text,
	        clicked = _ref.clicked,
	        styles = _ref.styles,
	        loading = _ref.loading,
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled;
	
	
	    var buttonStyles = [_ButtonModule2.default.Button];
	    if (color === 'primary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Primary].join(' ');
	    }
	
	    if (color === 'primary' && loading) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonLoading].join(' ');
	    }
	
	    if (color === 'primary' && disabled) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonDisabled].join(' ');
	    }
	
	    if (color === 'secondary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Secondary].join(' ');
	    }
	
	    if (color === 'transparent') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Transparent].join(' ');
	    }
	
	    return _react2.default.createElement(
	        'button',
	        {
	            className: buttonStyles,
	            onClick: clicked,
	            style: styles,
	            disabled: loading ? loading : disabled },
	        loading ? "Chargement..." : text
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"src-components-Button----Button-module---Button---1lSPX","Primary":"src-components-Button----Button-module---Primary---3suM_","PrimaryButtonLoading":"src-components-Button----Button-module---PrimaryButtonLoading---3xicQ","PrimaryButtonDisabled":"src-components-Button----Button-module---PrimaryButtonDisabled---2iIO_","Secondary":"src-components-Button----Button-module---Secondary---3FwkJ","Transparent":"src-components-Button----Button-module---Transparent---1lisK"};

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(103);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(200);
	
	var _accountCircle = __webpack_require__(105);
	
	var _accountCircle2 = _interopRequireDefault(_accountCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    _class.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: '#1689DF', color: '#fff' } },
	            _react2.default.createElement(
	                'div',
	                { style: { maxWidth: 1170, padding: '20px 20px 40px', margin: 'auto' } },
	                _react2.default.createElement(SimpleSlider, null)
	            )
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	
	var AvatarImage = function AvatarImage(_ref) {
	    var alt = _ref.alt;
	    return _react2.default.createElement('img', { src: _accountCircle2.default, alt: alt, style: { with: 44, height: 34, marginRight: 6, marginBottom: 0 } });
	};
	
	var TestimonialItem1 = function TestimonialItem1() {
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: "20px 20px 10px" } },
	        _react2.default.createElement(
	            'em',
	            null,
	            'Aller au CPM a chang\xE9 ma vie plus que toute autre chose que j\'ai jamais faite. Pendant longtemps, j\'ai cru que je n\'avais pas de probl\xE8mes qui m\xE9ritaient de l\'attention.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '20px 0 0', display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement(AvatarImage, { alt: 'avis de Sephanie, Vanier, Ottawa' }),
	            ' St\xE9phanie Richelieu, Vanier'
	        )
	    );
	};
	
	var TestimonialItem2 = function TestimonialItem2() {
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: "20px 20px 10px" } },
	        _react2.default.createElement(
	            'em',
	            null,
	            'Ils m\'ont vraiment aid\xE9 \xE0 surmonter mon anxi\xE9t\xE9. La th\xE9rapeute \xE9tait vraiment \xE0 mon \xE9coute.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '20px 0 0', display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement(AvatarImage, { alt: 'avis de Eryn Zannier, Orleans' }),
	            ' Eryn Zannier, Orleans'
	        )
	    );
	};
	
	var TestimonialItem3 = function TestimonialItem3() {
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: "20px 20px 10px" } },
	        _react2.default.createElement(
	            'em',
	            null,
	            'Extr\xEAmement utile! Je suis tellement reconnaissante pour leur aide.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '20px 0 0', display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement(AvatarImage, { alt: 'avis de Justin Gravel , Ottawa' }),
	            ' Justin Gravel , Ottawa'
	        )
	    );
	};
	
	var SimpleSlider = function (_React$Component) {
	    _inherits(SimpleSlider, _React$Component);
	
	    function SimpleSlider() {
	        _classCallCheck(this, SimpleSlider);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    SimpleSlider.prototype.render = function render() {
	        var settings = {
	            dots: true,
	            infinite: true,
	            speed: 500,
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            autoplay: true,
	            autoplaySpeed: 7000,
	            dotsClass: 'slick-dots'
	        };
	        return _react2.default.createElement(
	            _reactSlick2.default,
	            settings,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(TestimonialItem1, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(TestimonialItem2, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(TestimonialItem3, null)
	            )
	        );
	    };
	
	    return SimpleSlider;
	}(_react2.default.Component);
	
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"HowItWorks":"src-components-Contents----Content-module---HowItWorks---1TE_t","ServiceList":"src-components-Contents----Content-module---ServiceList---2SZPI","DefinitionsTab":"src-components-Contents----Content-module---DefinitionsTab---1QLOg","TabItemList":"src-components-Contents----Content-module---TabItemList---Fm1d4","Active":"src-components-Contents----Content-module---Active---6ld2R","MobileTabTitle":"src-components-Contents----Content-module---MobileTabTitle---3Knzr","MobileTabWrapper":"src-components-Contents----Content-module---MobileTabWrapper---1qG3C","MobileTabContent":"src-components-Contents----Content-module---MobileTabContent---SblaM","MoreInfoWrapper":"src-components-Contents----Content-module---MoreInfoWrapper---1eWvE","MoreInfoItem":"src-components-Contents----Content-module---MoreInfoItem---3Jt7i","Horaire":"src-components-Contents----Content-module---Horaire---JuaIG","PhoneNumberInfo":"src-components-Contents----Content-module---PhoneNumberInfo---1QZTY","MoreInfoItemTitle":"src-components-Contents----Content-module---MoreInfoItemTitle---YUdwE","CheckIcon":"src-components-Contents----Content-module---CheckIcon---YxOkj","WhyItemTitle":"src-components-Contents----Content-module---WhyItemTitle---3uMCL","SideImageWhyUs":"src-components-Contents----Content-module---SideImageWhyUs---3koPl","SideImageTherapies":"src-components-Contents----Content-module---SideImageTherapies---2fUs2","SideContentWrapper":"src-components-Contents----Content-module---SideContentWrapper---28xBb","TherapieIndividuelle":"src-components-Contents----Content-module---TherapieIndividuelle---1ZyIu","TherapieCoupleWrapper":"src-components-Contents----Content-module---TherapieCoupleWrapper---2cxm1","TherapieCouple":"src-components-Contents----Content-module---TherapieCouple---pAAJY","PsychoeducationWrapper":"src-components-Contents----Content-module---PsychoeducationWrapper---mIxzN","SideImageWrapper":"src-components-Contents----Content-module---SideImageWrapper---3uSNR","GetStartedWrapper":"src-components-Contents----Content-module---GetStartedWrapper---3nVlt","GetStartedItem":"src-components-Contents----Content-module---GetStartedItem---3L09M","BenefitsImage":"src-components-Contents----Content-module---BenefitsImage---3iyHn","BenefitsWrapper":"src-components-Contents----Content-module---BenefitsWrapper---2pDiq","BenefitsTextWrapper":"src-components-Contents----Content-module---BenefitsTextWrapper---121Q-","AGetStarted":"src-components-Contents----Content-module---AGetStarted---1Woek"};

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ContentModule = __webpack_require__(18);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _servicesImage = __webpack_require__(115);
	
	var _servicesImage2 = _interopRequireDefault(_servicesImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.BenefitsWrapper },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 585, padding: '40px 20px', margin: 'auto' }, className: _ContentModule2.default.BenefitsTextWrapper },
	            _react2.default.createElement(
	                'h2',
	                { style: { marginBottom: 40 } },
	                'C\u2019est quoi les b\xE9n\xE9fices d\u2019une th\xE9rapie?'
	            ),
	            _react2.default.createElement('div', { style: { width: 100, height: 2, backgroundColor: '#1689DF', marginBottom: 40 } }),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Parfois, il est plus facile de parler \xE0 un \xE9tranger qu\'\xE0 des parents ou des amis mais encore mieux \xE0 un professionnel. Pendant une th\xE9rapie, un conseiller ou un th\xE9rapeute form\xE9 vous \xE9coute et vous aide \xE0 trouver vos propres r\xE9ponses aux probl\xE8mes, avec empathie sans vous juger.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Le th\xE9rapeute vous donnera le temps de parler, pleurer, crier ou simplement de penser. C\'est l\'occasion de regarder diff\xE9remment vos probl\xE8mes avec quelqu\'un qui va vous respecter vous et vos opinions.'
	                )
	            )
	        ),
	        _react2.default.createElement('div', { className: _ContentModule2.default.BenefitsImage, style: { backgroundImage: 'url(' + _servicesImage2.default + ')' } })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ContentModule = __webpack_require__(18);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var clicked = _ref.clicked;
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#F6F6F6' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 700, padding: '60px 20px', margin: 'auto', textAlign: 'center' } },
	            _react2.default.createElement(
	                'h2',
	                { style: { marginBottom: 16 } },
	                'Pourquoi attendre pour chercher de l\'aide?'
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Prenez un rendez-vous pour commencer un changement positif dans votre vie.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_Button2.default, { color: 'primary', text: 'R\xE9server en ligne', clicked: function clicked() {
	                            return (0, _gatsbyLink.navigateTo)('/reservation');
	                        } }),
	                    _react2.default.createElement(
	                        'a',
	                        { className: '',
	                            href: 'tel:+16132525227',
	                            style: { marginLeft: 20 }
	                        },
	                        _react2.default.createElement(_Button2.default, { color: 'secondary', text: '613-252-5227' })
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 900, padding: '40px 20px', margin: 'auto', fontSize: '1.1rem' } },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Bienvenue de la part de notre \xE9quipe. Le CPM est un centre multidisciplinaire compos\xE9 d\u2019un groupe de psychologue, de conseillers conjugaux et familiaux offrant du counseling et des th\xE9rapies dans la r\xE9gion d\u2019Ottawa et Gatineau. Nous offrons  du counseling individuel, du couple et de la famille. Notre objectif principal est que vous vous  sentiez  \xE9cout\xE9 et compris dans vos difficult\xE9s actuelles. Notre travail  se d\xE9roule dans un cadre  confidentiel et accueillant.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Nos th\xE9rapeutes utilisent les approches int\xE9gratives  et centr\xE9es sur le client. Th\xE9rapie cognitive et comportementale (TCC), Th\xE9rapies centr\xE9es sur les solutions, la th\xE9rapie psychodynamique, Programmation neurolinguistique (PNL) et plus encore.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Nous utilisons plusieurs approches de la th\xE9rapie familiale qui visent \xE0 am\xE9liorer la communication et le fonctionnement de la famille, \xE0 r\xE9soudre les conflits interpersonnels et \xE0 renforcer les habilet\xE9s d\'adaptation et de r\xE9solution de probl\xE8mes dans les familles.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Nos th\xE9rapeutes sont \xE0 votre service et peuvent travailler avec vous pour vous aider \xE0 trouver les moyens de relever les d\xE9fis auxquels vous \xEAtes confront\xE9s.'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _ContentModule = __webpack_require__(18);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: 'rgb(246, 246, 246)' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 1170, padding: '40px 20px', margin: 'auto', textAlign: 'center' } },
	            _react2.default.createElement(
	                'h2',
	                { style: { marginBottom: 40 } },
	                'Comment commencer?'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _ContentModule2.default.GetStartedWrapper },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.GetStartedItem, style: { display: 'flex', alignItems: 'center', flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        Number,
	                        null,
	                        '1'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Appelez-nous au ',
	                        _react2.default.createElement(
	                            'span',
	                            { onClick: function onClick() {
	                                    return (0, _google_conversion_mobile_call2.default)();
	                                } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'tel:+16132525227' },
	                                '613-252-5227'
	                            )
	                        ),
	                        ' (ou ',
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/reservation' },
	                            'r\xE9servez en ligne'
	                        ),
	                        ') et dites-nous ce qui vous pose probl\xE8me.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.GetStartedItem, style: { display: 'flex', alignItems: 'center', flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        Number,
	                        null,
	                        '2'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Nous fournissons la disponibilit\xE9 avec des th\xE9rapeutes sp\xE9cifiquement adapt\xE9s \xE0 vos besoins.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.GetStartedItem, style: { display: 'flex', alignItems: 'center', flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        Number,
	                        null,
	                        '3'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Rencontrez votre th\xE9rapeute et commencez la route pour vous am\xE9liorer.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Number = function Number(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                display: 'flex',
	                justifyContent: 'center',
	                alignItems: 'center',
	                width: 40,
	                height: 40,
	                borderRadius: '50%',
	                color: '#fff',
	                backgroundColor: '#4cae4c',
	                marginBottom: 20,
	                fontSize: '1.5rem'
	            } },
	        children
	    );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gatsbyLink = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#1689DF', color: '#fff' } },
	        _react2.default.createElement(
	            'div',
	            { style: {
	                    maxWidth: 800,
	                    margin: 'auto',
	                    padding: '40px 20px',
	                    minHeight: 320,
	                    display: 'flex',
	                    alignItems: 'center',
	                    justifyContent: 'center',
	                    flexDirection: 'column'
	                } },
	            _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                'On est \xE0 votre \xE9coute'
	            ),
	            _react2.default.createElement(
	                'p',
	                { style: { textAlign: 'center' } },
	                'Nos conseill\xE8res et conseillers travaillent de mani\xE8re confidentielle et adaptent leur approche \xE0 vos besoins individuels.  Votre th\xE9rapie commence par votre prise de rendez-vous qui est le premier pas vers le changement progressif.'
	            ),
	            _react2.default.createElement(_Button2.default, { color: 'transparent', text: 'PRENDRE RENDEZ-VOUS', clicked: function clicked() {
	                    return (0, _gatsbyLink.navigateTo)('/reservation');
	                } })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _Iframe = __webpack_require__(63);
	
	var _Iframe2 = _interopRequireDefault(_Iframe);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _ContentModule = __webpack_require__(18);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _iconOrloge = __webpack_require__(110);
	
	var _iconOrloge2 = _interopRequireDefault(_iconOrloge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var isMobile = _ref.isMobile,
	        history = _ref.history;
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#4D4D4D' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 1170, padding: '40px 20px', margin: 'auto' } },
	            _react2.default.createElement(
	                'div',
	                { className: _ContentModule2.default.MoreInfoWrapper },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.MoreInfoItem },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemBody },
	                        _react2.default.createElement(_Iframe2.default, { width: '100%', height: '240px', src: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyD5d58sVD8JymoPG0mWxmQP8glK9_m9cI4&q=427+McArthur+Ave,Ottawa,ON' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.MoreInfoItem, style: { backgroundColor: '#fff', marginBottom: '' + (isMobile ? '20px' : 0) } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemTitle },
	                        'Prendre Rendez-vous'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemBody, style: { padding: 20 } },
	                        _react2.default.createElement(
	                            'h2',
	                            { style: { margin: 0 }, className: _ContentModule2.default.PhoneNumberInfo },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'tel:+16132525227', target: '_blank', style: { textDecoration: 'underline' }, onClick: function onClick() {
	                                        return (0, _google_conversion_mobile_call2.default)();
	                                    } },
	                                '613-252-5227'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h5',
	                            { style: { color: "#92c83a", marginBottom: 10 } },
	                            '\u2022 Ligne Disponible'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'flex-end' } },
	                            _react2.default.createElement(_Button2.default, { text: 'R\xE9server en ligne', color: 'primary', clicked: function clicked() {
	                                    return (0, _gatsbyLink.navigateTo)('/reservation');
	                                } })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.MoreInfoItem, style: {
	                            backgroundImage: 'url(' + _iconOrloge2.default + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'top right', backgroundColor: '#fff'
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemTitle },
	                        'Horaire d\'ouverture'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemBody, style: { padding: 20 } },
	                        _react2.default.createElement(
	                            'p',
	                            { className: _ContentModule2.default.Horaire },
	                            'Lundi \xE0 Vendredi: ',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                '9AM \xE0 12PM'
	                            ),
	                            ' et ',
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                '1PM \xE0 5PM, ouvert jusqu\'\xE0 8PM au besoin'
	                            ),
	                            ' ',
	                            _react2.default.createElement('br', null),
	                            'Ferm\xE9 le Week-end'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentModule = __webpack_require__(18);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _arrowRight = __webpack_require__(106);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#f6f6f6' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 1170, padding: '40px 20px', margin: 'auto', display: 'flex' }, className: '' },
	            _react2.default.createElement(
	                'div',
	                { className: _ContentModule2.default.ServiceWrapper },
	                _react2.default.createElement(
	                    'h1',
	                    { style: { margin: '0 0 10px 0' } },
	                    'Services de Th\xE9rapie'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'D\xE9couvrez le meilleur pour vous'
	                ),
	                _react2.default.createElement('div', { style: { width: 100, height: 2, backgroundColor: '#1689DF', marginBottom: 40 } }),
	                _react2.default.createElement(
	                    'p',
	                    { style: { textAlign: 'left' } },
	                    'Notre \xE9quipe est fi\xE8re de pouvoir vous venir en aide. Notre expertise couvre l\u2019\xE9ventail des probl\xE8mes et des conditions psychologiques, du plus \xE9l\xE9mentaire au plus complexe. Cela inclut:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.ServiceList },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Angoisses'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Phobies et peurs '
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Difficult\xE9s relationnelles'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' D\xE9pressions'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Probl\xE8mes familiaux '
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Burnout'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Difficult\xE9s professionnelles '
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Soucis d\u2019identit\xE9 '
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Traumatismes '
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Manque d\u2019estime de soi'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' D\xE9pendances'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'La liste susmentionn\xE9e n\u2019est pas exhaustive, et avec plaisir nous ferons de notre mieux pour vous aider dans  vos difficult\xE9s.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PsychoEducation = exports.TherapieFamille = exports.TherapieCouple = exports.TherapieIndividuelle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentModule = __webpack_require__(18);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _iconDone = __webpack_require__(109);
	
	var _iconDone2 = _interopRequireDefault(_iconDone);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _therapieIndividuelleImage = __webpack_require__(118);
	
	var _therapieIndividuelleImage2 = _interopRequireDefault(_therapieIndividuelleImage);
	
	var _therapieDeCouple = __webpack_require__(116);
	
	var _therapieDeCouple2 = _interopRequireDefault(_therapieDeCouple);
	
	var _therapieFamiliale = __webpack_require__(117);
	
	var _therapieFamiliale2 = _interopRequireDefault(_therapieFamiliale);
	
	var _psychoeducation = __webpack_require__(114);
	
	var _psychoeducation2 = _interopRequireDefault(_psychoeducation);
	
	var _pourquoiLeCpm = __webpack_require__(113);
	
	var _pourquoiLeCpm2 = _interopRequireDefault(_pourquoiLeCpm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.SideImageWrapper },
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageWhyUs,
	            style: { backgroundImage: 'url(' + _pourquoiLeCpm2.default + ')' }
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                    'h1',
	                    { style: { margin: '0 0 40px 0' } },
	                    'Pourquoi le CPM?'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { className: _ContentModule2.default.WhyItemTitle },
	                    _react2.default.createElement('img', { src: _iconDone2.default, className: _ContentModule2.default.CheckIcon }),
	                    'Nous sommes professionnels'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Tous nos th\xE9rapeutes sont des professionnels bien form\xE9s et exp\xE9riment\xE9s. Nos th\xE9rapeutes ont satisfait aux exigences rigoureuses de formation et ils sont pr\xEAts pour vous assurer le meilleur soutien.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { className: _ContentModule2.default.WhyItemTitle },
	                    _react2.default.createElement('img', { src: _iconDone2.default, className: _ContentModule2.default.CheckIcon }),
	                    'On est rapide'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Il peut \xEAtre difficile d\'attendre des jours ou des semaines jusqu\'\xE0 votre premier rendez-vous surtout durant les p\xE9riodes de vuln\xE9rabilit\xE9. Avec le CPM vous obtiendrez un rendez-vous dans les plus brefs d\xE9lais.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { className: _ContentModule2.default.WhyItemTitle },
	                    _react2.default.createElement('img', { src: _iconDone2.default, className: _ContentModule2.default.CheckIcon }),
	                    'Service abordable'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Nous avons des prix abordables et nous pouvons aussi \xEAtre pris en charge par certaines assurances mais nos services ne sont pas couverts par l\'OHIP.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Nos honoraires sont de 180$ l\'heure pour la s\xE9ance individuelle et 250$ pour la s\xE9ance de couple ou de famille qui dure une heure et demie. Si vous avez des difficult\xE9s financi\xE8res, n\u2019h\xE9sitez pas \xE0 ',
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/contact' },
	                        'communiquer avec nous'
	                    ),
	                    ' pour discuter si vous pouvez avoir un prix r\xE9duit.'
	                )
	            )
	        )
	    );
	};
	
	var TherapieIndividuelle = exports.TherapieIndividuelle = function TherapieIndividuelle() {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.SideImageWrapper },
	        _react2.default.createElement(
	            'div',
	            { className: [_ContentModule2.default.SideContentWrapper, _ContentModule2.default.TherapieIndividuelle].join(' ') },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Th\xE9rapie Individuelle'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'La th\xE9rapie individuelle vise \xE0 traiter les troubles \xE9motionnels, relationnels et psychologiques de l\u2019individu. Cette prise en charge est disponible aux adolescents et aux adultes.'
	            )
	        ),
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageTherapies,
	            style: { backgroundImage: 'url(' + _therapieIndividuelleImage2.default + ')' }
	        })
	    );
	};
	
	var TherapieCouple = exports.TherapieCouple = function TherapieCouple() {
	    return _react2.default.createElement(
	        'div',
	        { className: [_ContentModule2.default.SideImageWrapper, _ContentModule2.default.TherapieCoupleWrapper].join(' ') },
	        _react2.default.createElement('div', {
	            className: [_ContentModule2.default.SideImageTherapies, _ContentModule2.default.TherapieCouple].join(" "),
	            style: { backgroundImage: 'url(' + _therapieDeCouple2.default + ')' }
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Th\xE9rapie de Couple'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'La th\xE9rapie de couple s\u2019adresse aux couples, mari\xE9s ou non, et aux personnes confront\xE9es aux probl\xE8mes de la vie commune. Elle vise \xE0 aider les couples \xE0 surmonter les difficult\xE9s relationnelles et \xE0 renforcer la proximit\xE9 \xE9motionnelle et \xE0 r\xE9tablir leur relation \xE0 un niveau de fonctionnement plus sain et plus \xE9quilibr\xE9.'
	            )
	        )
	    );
	};
	
	var TherapieFamille = exports.TherapieFamille = function TherapieFamille() {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.SideImageWrapper },
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Th\xE9rapie Familiale'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'La th\xE9rapie familiale vise la famille en tant que syst\xE8me social. Elle s\u2019adresse \xE0 toutes familles ayant des difficult\xE9s relationnelles \xE0 am\xE9liorer la compr\xE9hension mutuelle et accro\xEEtre le soutien affectif des membres de la famille, en particulier pendant les phases de transition (adolescence des enfants, s\xE9paration des parents, ch\xF4mage, retraite, etc.. ) et des \xE9v\xE8nements difficiles, comme la mort ou une maladie grave dans la famille.'
	            )
	        ),
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageTherapies,
	            style: { backgroundImage: 'url(' + _therapieFamiliale2.default + ')' }
	        })
	    );
	};
	
	var PsychoEducation = exports.PsychoEducation = function PsychoEducation() {
	    return _react2.default.createElement(
	        'div',
	        { className: [_ContentModule2.default.SideImageWrapper, _ContentModule2.default.PsychoeducationWrapper].join(' ') },
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageTherapies,
	            style: { backgroundImage: 'url(' + _psychoeducation2.default + ')' }
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Psycho\xE9ducation'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Nous faisons de la psycho\xE9ducation sur  une vari\xE9t\xE9 de probl\xE8mes d\'\xE9ducation des enfants et des adolescents. L\'objectif est d\'aider les parents \xE0 g\xE9rer efficacement les difficult\xE9s comportementales et \xE9motionnelles de leur enfant ou adolescent.'
	            )
	        )
	    );
	};

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FormWrapper":"src-components-Forms----Forms-module---FormWrapper---3L7T-","FormBody":"src-components-Forms----Forms-module---FormBody---3TiIQ","InputStyle":"src-components-Forms----Forms-module---InputStyle---UGTYF","SelectInput":"src-components-Forms----Forms-module---SelectInput---SEdCf","TextArea":"src-components-Forms----Forms-module---TextArea---2E1gV","Label":"src-components-Forms----Forms-module---Label---3BeuF","FormRowWrapper":"src-components-Forms----Forms-module---FormRowWrapper---2E5Ra","FormRow":"src-components-Forms----Forms-module---FormRow---30gnY","ProgressItem":"src-components-Forms----Forms-module---ProgressItem---3tsWY","Active":"src-components-Forms----Forms-module---Active---CQvNM"};

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormsModule = __webpack_require__(37);
	
	var _FormsModule2 = _interopRequireDefault(_FormsModule);
	
	var _arrow_down24px = __webpack_require__(56);
	
	var _arrow_down24px2 = _interopRequireDefault(_arrow_down24px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            firstName: '',
	            lastName: '',
	            phoneNumber: '',
	            email: '',
	            domaine: 'Psychothérapie/ Consultation Individuelle'
	        }, _this.handleInputChange = function (e) {
	            var state = _extends({}, _this.state);
	            state[e.target.getAttribute('name')] = e.target.value;
	            _this.setState(_extends({}, state));
	        }, _this.handleLeadFormClicked = function () {
	            (0, _gatsbyLink.navigateTo)({
	                pathname: '/reservation',
	                data: {
	                    from: 'homepage',
	                    state: _this.state
	                }
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _class.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { className: _FormsModule2.default.FormWrapper },
	            _react2.default.createElement(
	                'div',
	                { style: {
	                        textTransform: 'uppercase',
	                        backgroundColor: '#0071BC', color: 'white',
	                        height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center'
	                    } },
	                'Formulaire de rendez-vous'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _FormsModule2.default.FormBody },
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Pr\xE9nom(s)'
	                    ),
	                    _react2.default.createElement('input', { name: 'firstName', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Nom(s)'
	                    ),
	                    _react2.default.createElement('input', { name: 'lastName', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'T\xE9l\xE9phone'
	                    ),
	                    _react2.default.createElement('input', { name: 'phoneNumber', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Courriel'
	                    ),
	                    _react2.default.createElement('input', { name: 'email', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 20 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Domaine'
	                    ),
	                    _react2.default.createElement(
	                        'select',
	                        { name: 'domaine', className: _FormsModule2.default.SelectInput, style: { backgroundImage: 'url(' + _arrow_down24px2.default + ')' }, onChange: function onChange(e) {
	                                return _this2.handleInputChange(e);
	                            } },
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Th\xE9rapie Individuelle' },
	                            'Th\xE9rapie Individuelle'
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Th\xE9rapie de Couple' },
	                            'Th\xE9rapie de Couple'
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Th\xE9rapie Familiale' },
	                            'Th\xE9rapie Familiale'
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'T\xE9l\xE9th\xE9rapie' },
	                            'T\xE9l\xE9th\xE9rapie'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_Button2.default, { color: 'primary', text: 'Prendre rendez-vous', styles: styles, clicked: this.handleLeadFormClicked })
	                )
	            )
	        );
	    };
	
	    return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	
	
	var styles = {
	    width: "100%",
	    borderRadius: 0
	};
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _callIcon = __webpack_require__(107);
	
	var _callIcon2 = _interopRequireDefault(_callIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                backgroundColor: '#FF7F00',
	                height: 58,
	                width: 58,
	                padding: '18px 12px 8px',
	                position: 'fixed',
	                bottom: 20,
	                right: 20,
	                borderRadius: '50%'
	            }, onClick: function onClick() {
	                if (window.gtag) {
	                    gtag('event', 'conversion', {
	                        'send_to': 'AW-997202270/gOfzCM28rYQBEN6ywNsD'
	                    });
	                }
	            } },
	        _react2.default.createElement(
	            'a',
	            { href: 'tel:+16132525227' },
	            _react2.default.createElement('img', { src: _callIcon2.default, style: { width: 34, margin: 0 } })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fillFormIcon = __webpack_require__(108);
	
	var _fillFormIcon2 = _interopRequireDefault(_fillFormIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                backgroundColor: '#4cae4c',
	                height: 58,
	                width: 58,
	                padding: '18px 12px 8px',
	                position: 'fixed',
	                bottom: 20,
	                right: 'calc(20px + 58px + 10px)',
	                borderRadius: '50%'
	            } },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/reservation' },
	            _react2.default.createElement('img', { src: _fillFormIcon2.default, style: { width: 34, margin: 0 } })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _reactPlayer = __webpack_require__(100);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LeadForm = __webpack_require__(146);
	
	var _LeadForm2 = _interopRequireDefault(_LeadForm);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _Mozaique = __webpack_require__(149);
	
	var _Mozaique2 = _interopRequireDefault(_Mozaique);
	
	var _MozaiqueModule = __webpack_require__(191);
	
	var _MozaiqueModule2 = _interopRequireDefault(_MozaiqueModule);
	
	var _videos = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroSection = function HeroSection(props) {
	    return _react2.default.createElement(
	        _Mozaique2.default,
	        props,
	        _react2.default.createElement(
	            'div',
	            { className: _MozaiqueModule2.default.Wrapper },
	            _react2.default.createElement(
	                'div',
	                { className: _MozaiqueModule2.default.InnerContentLeft },
	                _react2.default.createElement(
	                    'h1',
	                    { className: _MozaiqueModule2.default.H1 },
	                    'Service de Counselling et Th\xE9rapie '
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _MozaiqueModule2.default.SubH1 },
	                    'D\xE9couvrez comment le CPM peut vous aider'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _MozaiqueModule2.default.VideoWrapper },
	                    _react2.default.createElement(_reactPlayer2.default, {
	                        url: _videos.HERO_VIDEO_FR,
	                        config: {
	                            wistia: {
	                                options: {
	                                    playerColor: "#1689DF"
	                                }
	                            }
	                        },
	                        width: '100%',
	                        height: '100%'
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { fontSize: '0.8rem', padding: '10px 0 0' }, className: _MozaiqueModule2.default.VideoFooterText },
	                    _react2.default.createElement(
	                        'div',
	                        { style: {
	                                fontSize: '0.9rem',
	                                backgroundColor: "#04040487",
	                                padding: '0 10px',
	                                fontWeight: 500,
	                                display: 'inline-block'
	                            } },
	                        'Nos consultations peuvent \xEAtre partiellement rembours\xE9es par certaines assurances.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: {
	                                backgroundColor: "#04040487",
	                                padding: '0 10px',
	                                display: 'inline-block'
	                            } },
	                        'Les places sont limit\xE9es due \xE0 la forte demande des services de consultation.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { padding: 10, position: props.position, top: props.top }, className: _MozaiqueModule2.default.FullLeadForm },
	                _react2.default.createElement(_LeadForm2.default, props)
	            ),
	            _react2.default.createElement(MobileHeroCallToAction, props)
	        )
	    );
	};
	
	var MobileHeroCallToAction = function MobileHeroCallToAction(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 20 }, className: _MozaiqueModule2.default.MobileCallToAction },
	        _react2.default.createElement(_Button2.default, { color: 'primary', text: 'R\xE9servez une Consultation en Ligne', clicked: function clicked() {
	                return (0, _gatsbyLink.navigateTo)('/reservation');
	            }, styles: buttonStyles }),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: 10 } },
	            _react2.default.createElement(
	                'h4',
	                { style: { color: "#fff", marginBottom: 10, fontSize: '0.9rem' } },
	                'Ou appelez nous maintenant'
	            ),
	            _react2.default.createElement(
	                'a',
	                { href: 'tel:+16132525227', onClick: function onClick() {
	                        (0, _google_conversion_mobile_call2.default)();
	                    } },
	                _react2.default.createElement(_Button2.default, { color: 'secondary', text: '613-252-5227', styles: buttonStyles, clicked: function clicked() {
	                        return (0, _google_conversion_mobile_call2.default)();
	                    } })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { fontSize: '0.7rem', padding: '10px 0 0', color: '#fff' } },
	            _react2.default.createElement(
	                'div',
	                { style: {
	                        fontSize: '0.9rem',
	                        backgroundColor: "#04040487",
	                        padding: '4px 10px 0',
	                        fontWeight: 500
	                    } },
	                'Nos consultations peuvent \xEAtre partiellement rembours\xE9es par certaines assurances.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: {
	                        backgroundColor: "#04040487",
	                        padding: '0 10px 4px'
	                    } },
	                'Les places sont limit\xE9es dues \xE0 la forte demande des services de consultation. '
	            )
	        )
	    );
	};
	
	var buttonStyles = {
	    padding: 10,
	    minWidth: 200
	};
	
	exports.default = HeroSection;
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mozaiqueMobile = __webpack_require__(111);
	
	var _mozaiqueMobile2 = _interopRequireDefault(_mozaiqueMobile);
	
	var _mozaique = __webpack_require__(112);
	
	var _mozaique2 = _interopRequireDefault(_mozaique);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    _class.prototype.render = function render() {
	        var _props = this.props,
	            isMobile = _props.isMobile,
	            windowWidth = _props.windowWidth;
	
	        return _react2.default.createElement(
	            'div',
	            { style: {
	                    backgroundImage: 'url(' + (windowWidth < 842 ? _mozaiqueMobile2.default : _mozaique2.default) + ')',
	                    boxShadow: "inset 0 0 0 10000px rgba(0,0,0,.65)",
	                    backgroundSize: "cover",
	                    backgroundPosition: "center"
	
	                } },
	            this.props.children
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"src-components-HeroSection----Mozaique-module---Wrapper---31uKw","InnerContentLeft":"src-components-HeroSection----Mozaique-module---InnerContentLeft---2bghz","FullLeadForm":"src-components-HeroSection----Mozaique-module---FullLeadForm---2NLAg","VideoFooterText":"src-components-HeroSection----Mozaique-module---VideoFooterText---2Csz0","MobileCallToAction":"src-components-HeroSection----Mozaique-module---MobileCallToAction---2prWr","SubH1":"src-components-HeroSection----Mozaique-module---SubH1---3EDLs","H1":"src-components-HeroSection----Mozaique-module---H1---2FXUN","VideoWrapper":"src-components-HeroSection----Mozaique-module---VideoWrapper---3oPCX","H1Call":"src-components-HeroSection----Mozaique-module---H1Call---mn0WP","H1Ottawa":"src-components-HeroSection----Mozaique-module---H1Ottawa---323Ig","SubH1Ottawa":"src-components-HeroSection----Mozaique-module---SubH1Ottawa---e3l43"};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIframe = __webpack_require__(52);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	        var width = _ref.width,
	            height = _ref.height,
	            src = _ref.src;
	        return _react2.default.createElement(_reactIframe2.default, {
	                width: width,
	                height: height,
	                url: src,
	                display: 'initial',
	                position: 'relative',
	                allowFullScreen: true });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallAction = __webpack_require__(147);
	
	var _CallAction2 = _interopRequireDefault(_CallAction);
	
	var _FillFormAction = __webpack_require__(148);
	
	var _FillFormAction2 = _interopRequireDefault(_FillFormAction);
	
	var _MobileActionsModule = __webpack_require__(192);
	
	var _MobileActionsModule2 = _interopRequireDefault(_MobileActionsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: _MobileActionsModule2.default.ActionWrapper },
	        _react2.default.createElement(_CallAction2.default, null),
	        _react2.default.createElement(_FillFormAction2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ActionWrapper":"src-components-MobileActions----MobileActions-module---ActionWrapper---1upbI"};

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Carousel = __webpack_require__(137);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _HomePage = __webpack_require__(140);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _MoreInfo = __webpack_require__(143);
	
	var _MoreInfo2 = _interopRequireDefault(_MoreInfo);
	
	var _Footer = __webpack_require__(78);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Hero = __webpack_require__(309);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Services = __webpack_require__(144);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _WhyUs = __webpack_require__(145);
	
	var _WhyUs2 = _interopRequireDefault(_WhyUs);
	
	var _Listen = __webpack_require__(142);
	
	var _Listen2 = _interopRequireDefault(_Listen);
	
	var _HowToGetStarted = __webpack_require__(141);
	
	var _HowToGetStarted2 = _interopRequireDefault(_HowToGetStarted);
	
	var _Benefits = __webpack_require__(138);
	
	var _Benefits2 = _interopRequireDefault(_Benefits);
	
	var _GetStarted = __webpack_require__(139);
	
	var _GetStarted2 = _interopRequireDefault(_GetStarted);
	
	var _MobileActions = __webpack_require__(150);
	
	var _MobileActions2 = _interopRequireDefault(_MobileActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            isMobile: false,
	            windowWidth: null,
	            isLoading: true,
	            scrollPosition: 0
	        }, _this.updateDeviceState = function () {
	            return _this.setState({ isMobile: window.innerWidth < 768, windowWidth: window.innerWidth });
	        }, _this.updateScrollPosition = function () {
	            return _this.setState({ scrollPosition: window.scrollY });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.setState({
	            isMobile: window.innerWidth < 768,
	            windowWidth: window.innerWidth,
	            isLoading: false
	        }, function () {
	            window.addEventListener("resize", _this2.updateDeviceState);
	            window.addEventListener("scroll", _this2.updateScrollPosition);
	        });
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	        window.removeEventListener("resize", this.updateDeviceState);
	        window.removeEventListener("scroll", this.updateScrollPosition);
	    };
	
	    _class.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('html', { lang: 'fr' }),
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Psychologue Ottawa et Gatineau - Psychoth\xE9rapie et Counselling en Anglais et Fran\xE7ais'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'Traversez-vous des \xE9preuves difficiles? Si oui, vous n\'\xEAtes pas seul. Faites le premier pas vers le chemain du bien \xEAtre en parlant \xE0 un professionel qui vous aidera \xE0 regagner control et ...' })
	            ),
	            _react2.default.createElement(_Hero2.default, _extends({}, this.state, this.props)),
	            _react2.default.createElement(_Carousel2.default, null),
	            _react2.default.createElement(_HomePage2.default, null),
	            _react2.default.createElement(_Services2.default, null),
	            _react2.default.createElement(_WhyUs2.default, null),
	            _react2.default.createElement(_Listen2.default, null),
	            _react2.default.createElement(_WhyUs.TherapieIndividuelle, null),
	            _react2.default.createElement(_WhyUs.TherapieCouple, null),
	            _react2.default.createElement(_WhyUs.TherapieFamille, null),
	            _react2.default.createElement(_WhyUs.PsychoEducation, null),
	            _react2.default.createElement(_HowToGetStarted2.default, null),
	            _react2.default.createElement(_Benefits2.default, null),
	            _react2.default.createElement(_GetStarted2.default, null),
	            _react2.default.createElement(_MoreInfo2.default, _extends({ isMobile: this.state.isMobile }, this.props)),
	            _react2.default.createElement(_Footer2.default, null),
	            this.state.scrollPosition > 600 ? _react2.default.createElement(_MobileActions2.default, null) : null
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-712509c839d66bb22c31.js